import React from 'react';

export type GoalStatus = 'pending' | 'in_progress' | 'reached' | 'failed' | 'delayed' | 'postponed' | 'canceled';

interface GoalStatusBadgeProps {
  status: GoalStatus;
  className?: string;
}

const GoalStatusBadge: React.FC<GoalStatusBadgeProps> = ({ status, className = '' }) => {
  const getStatusColor = (status: GoalStatus) => {
    switch (status) {
      case 'reached':
        return 'bg-[var(--color-success-100)] text-[var(--color-success-800)]';
      case 'failed':
        return 'bg-[var(--color-error-100)] text-[var(--color-error-800)]';
      case 'in_progress':
        return 'bg-[var(--color-brand-100)] text-[var(--color-brand-800)]';
      case 'delayed':
        return 'bg-[var(--color-warning-100)] text-[var(--color-warning-800)]';
      case 'postponed':
        return 'bg-[var(--color-warning-100)] text-[var(--color-warning-800)]';
      case 'canceled':
        return 'bg-[var(--color-neutral-100)] text-[var(--color-neutral-800)]';
      default:
        return 'bg-[var(--color-neutral-100)] text-[var(--color-neutral-800)]';
    }
  };

  return (
    <span
      className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(status)} ${className}`}
    >
      {status.replace('_', ' ').toUpperCase()}
    </span>
  );
};

export default GoalStatusBadge;

